<template>

  <div class="buyer-type-toggle buyer-type-toggle--3col">
     <button
      v-for="type in buyerTypes"
      :key="type.value"
      type="button"
      class="buyer-type-btn"
      :class="{ 'is-active': value === type.value }"
      :disabled="disabled"
      :aria-pressed="value === type.value"
      @click="selectType(type.value)"
    >
       <i :class="type.icon"></i> <span>{{ type.label }}</span
      > </button
    >
  </div>

</template>

<script>
  import {
    EINVOICE_BUYER_TYPE,
    EINVOICE_BUYER_TYPE_LABEL,
    EINVOICE_BUYER_TYPE_ICON,
  } from '@/utils/einvoice.enum'

  export default {
    name: 'BuyerTypeToggle',

    props: {
      value: {
        type: String,
        default: EINVOICE_BUYER_TYPE.ENTERPRISE,
        validator: (v) => Object.values(EINVOICE_BUYER_TYPE).includes(v),
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      buyerTypes() {
        return [
          {
            value: EINVOICE_BUYER_TYPE.ENTERPRISE,
            label: EINVOICE_BUYER_TYPE_LABEL[EINVOICE_BUYER_TYPE.ENTERPRISE],
            icon: EINVOICE_BUYER_TYPE_ICON[EINVOICE_BUYER_TYPE.ENTERPRISE],
          },
          {
            value: EINVOICE_BUYER_TYPE.INDIVIDUAL,
            label: EINVOICE_BUYER_TYPE_LABEL[EINVOICE_BUYER_TYPE.INDIVIDUAL],
            icon: EINVOICE_BUYER_TYPE_ICON[EINVOICE_BUYER_TYPE.INDIVIDUAL],
          },
        ]
      },
    },

    methods: {
      selectType(type) {
        if (!this.disabled && type !== this.value) {
          this.$emit('input', type)
          this.$emit('change', type)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  $primary: #3699ff;
$primary-light: #e1f0ff;
$primary-dark: #2b7de9;
$neutral-100: #f4f5f7;
$neutral-200: #e5e7eb;
$neutral-300: #d1d5db;
$neutral-500: #6b7280;
$neutral-700: #374151;
$radius-md: 10px;

.buyer-type-toggle {
  display: flex;
  gap: 0.5rem;
  padding: 4px;
  background: $neutral-100;
  border-radius: $radius-md;

  &--3col {
    .buyer-type-btn {
      flex: 1;
    }
  }
}

.buyer-type-btn {
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.55rem;
  padding: 0.75rem 0.5rem;
  border: 1px solid transparent;
  border-radius: $radius-md - 4px;
  background: transparent;
  color: $neutral-500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  i {
    // font-size: 1.25rem;
    transition: transform 0.2s ease;
  }

  span {
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: -0.01em;
  }

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.6);
    color: $neutral-700;

    i {
      transform: scale(1.05);
    }
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &.is-active {
    background: white;
    border-color: $neutral-200;
    color: $primary-dark;
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.06),
      0 1px 2px rgba(0, 0, 0, 0.04);

    i {
      transform: scale(1.05);
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

// Responsive: stack vertically on mobile
@media (max-width: 575px) {
  .buyer-type-toggle {
    flex-direction: column;

    &--3col .buyer-type-btn {
      flex-direction: row;
      justify-content: flex-start;
      gap: 0.75rem;
      padding: 0.75rem 1rem;

      i {
        // font-size: 1rem;
      }

      span {
        // font-size: 0.875rem;
      }
    }
  }
}
</style>
